import React from "react";
import { DislikesIcon, LikesIcon } from "assets/icons";
import "./style.scss";
import Divider from "components/BaseWidgets/divider";
import dummyUser from "assets/images/png/default-user.png";
import { useNavigate } from "react-router-dom";
import DOMPurify from "dompurify";

function subBlog({ EachBlogs, isTrue = false }) {
  const navigate = useNavigate();

  const handleRedirect = (id) => {
    if (isTrue) {
      navigate(`/success-stories/details/${id}`);
    } else {
      navigate(`/blog/details/${id}`);
    }
  };

  const handleLinkClick = (e) => {
    const target = e.target.closest("a");
    if (target) {
      e.preventDefault();
      e.stopPropagation();
      const url = target.getAttribute("href");
      if (url) {
        window.open(
          /^https?:\/\//i.test(url) ? url : `https://${url}`,
          "_blank",
          "noopener,noreferrer"
        );
      }
    }
  };

  return (
    <div
      onClick={() => handleRedirect(EachBlogs?.id)}
      className="more-blogs"
    >
      <div className="blog-image">
        <img src={EachBlogs.blogcover} alt="Blog cover" />
      </div>

      <div className="blog-data">
        <h3 className="font-title-xs fw-700">
          {isTrue ? EachBlogs.name : EachBlogs.title}
        </h3>

        {/* blog info — likely plain text but sanitized just in case */}
        {!isTrue && (
          <div
            className="font-body-xs fw-400 mt-1 grey-shade1 html-clamp html-clamp--1"
            onClick={handleLinkClick}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(EachBlogs.info || "", {
                ADD_ATTR: ["target", "rel"],
              }),
            }}
          />
        )}

        {isTrue ? (
          <>
            <p className="font-body-xs fw-400 grey-shade mt-1">
              Posted on: {EachBlogs.blogTime}
            </p>

            {/* success story description — may contain links, bold, lists etc */}
            <div
              className="font-body-xs fw-400 text-black mt-2 leading-5 html-clamp html-clamp--3"
              onClick={handleLinkClick}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(EachBlogs.description || "", {
                  ADD_ATTR: ["target", "rel"],
                }),
              }}
            />
          </>
        ) : (
          <>
            <div className="author-data flex items-center gap-1">
              <div className="user-area flex items-center gap-1">
                <img
                  src={EachBlogs.authorPic || dummyUser}
                  alt="Author"
                  onError={(e) => {
                    e.currentTarget.src = dummyUser;
                  }}
                />
                <p className="font-body-xs fw-600">{EachBlogs.author}</p>
              </div>
              <Divider type="vertical" className="custom-divider" />
              <p className="font-body-xs fw-400 grey-shade">
                {EachBlogs.blogTime}
              </p>
            </div>

            <div className="blog-stats flex items-center gap-4 mt-1">
              <div className="stat-area flex items-center gap-1">
                <LikesIcon />
                <p className="font-body-small">{EachBlogs.blogLikes}</p>
              </div>
              <div className="stat-area flex items-center gap-1">
                <DislikesIcon />
                <p className="font-body-small">{EachBlogs.blogDislikes}</p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default subBlog;
